import {pageBackIcon} from "./icons";
import UrlHelpers from "./url";
import {i18n} from "./i18n";

// export class ContextActions {
    export function setContextActions (dapi:any, i18n:i18n, options: IContextAction[]):void {
        let ctx: Array<IContextAction> = new Array<IContextAction>();
        // ctx.push({
        //     title: i18n.getTranslation('context_action_page_back_label'), //"Zurück",
        //     icon:pageBackIcon,
        //     callback: () => {
        //         dapi.closeResourceIfMainResource();
        //         let parent = UrlHelpers.getLinkRelHref('parent');
        //         if(parent) {
        //             dapi.publishLocation(parent);
        //             // window.location.reload(true);
        //             window.open(parent, '_self');
        //         }
        //     }
        // });
        if(options !== null && options !== undefined && options.length > 0) {
            ctx = ctx.concat(options);
        }
        if(ctx.length>0) {
            dapi.setContextActions(ctx);
        }
    }
// }